import { put, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import { ADD_COLOR_TO_SELECTED_COLORS } from 'features/product-info/ducks/product-tint-service';

/**
 * Событие должно срабатывать при выборе цвета в модальном окне Роботинта
 *
 * @see https://tracker.yandex.ru/PCP-10342
 */
export const gaClickSubmitColorSelectButton = createAction('GA:clickButton')<{
  elementType: 'button';
  elementBlock: 'productDetail'; // блок, в котором расположен элемент
  elementName: 'outstoreServices / colors';
  elementText: 'Выбрать цвет для колеровки';
}>();

function* putGaClickSubmitColorSelectButton() {
  yield put(
    gaClickSubmitColorSelectButton({
      elementType: 'button',
      elementBlock: 'productDetail',
      elementName: 'outstoreServices / colors',
      elementText: 'Выбрать цвет для колеровки',
    }),
  );
}

export function* runGaClickSubmitColorSelectButtonDetector() {
  yield takeEvery(ADD_COLOR_TO_SELECTED_COLORS, () => putGaClickSubmitColorSelectButton());
}
